import { IonText } from '@ionic/react'
import moment from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'
import { Chip } from '../../../components'

type Props = {
  title: string
  orderSequence: string
  img: string
  createdDate: string
  orderType: 'BUY' | 'SELL'
  status: 'DONE' | 'YET'
}

export const ProductInfo: React.FC<Props> = ({ title, orderSequence, img, createdDate, orderType, status }) => {
  return (
    <>
      <ProductInfoContainer>
        <img
          src={img}
          alt={'이미지'}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            currentTarget.src = '/img/thumbnail.svg'
          }}
        />
        <div className="product-info">
          <IonText className="title">{title}</IonText>
          <IonText className="orderSequence">{`주문번호 : ${orderSequence}`}</IonText>
          <BetweenWrap>
            <IonText className="time">{`${moment(new Date(createdDate)).format('HH:MM')}`}</IonText>
            {status === 'YET' && orderType === 'SELL' && <Chip type="lightBlue">매도 등록</Chip>}
            {status === 'YET' && orderType === 'BUY' && <Chip type="lightRed">매수 등록</Chip>}
            {status === 'DONE' && orderType === 'SELL' && <Chip type="gray">매도 완료</Chip>}
            {status === 'DONE' && orderType === 'BUY' && <Chip type="gray">매수 완료</Chip>}
          </BetweenWrap>
        </div>
      </ProductInfoContainer>
    </>
  )
}

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  img {
    border-radius: 7px;
    min-width: 52px;
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .product-info {
    grid-area: 1 / 2 / 2 / 6;
    display: flex;
    flex-direction: column;
    font-size: 15px;
    .orderSequence {
      white-space: nowrap;
      color: var(--ion-color-primary_light);
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 40px;
    }
    .time {
      font-size: 11px;
      font-weight: 400;
      color: #888888;
    }
  }
`

const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
`
